import { render, staticRenderFns } from "./reconsideration-request.vue?vue&type=template&id=e857396c&scoped=true&"
import script from "./reconsideration-request.vue?vue&type=script&lang=js&"
export * from "./reconsideration-request.vue?vue&type=script&lang=js&"
import style0 from "./reconsideration-request.vue?vue&type=style&index=0&id=e857396c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e857396c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
